<template>
  <div class="lp-check-group-container">
    <div class="lp-check-container" v-for="(item, idx) in list" :key="'chk'+idx" @click="clickCheck(item)">
      <div class="unselect color-shape" :style="colorStyle(item)">
        <i v-if="isSelected(item)" :style="checkStyle(item)" class="material-icons checked-icon">check</i>
      </div>
      <!--      <div class="lp-label">{{ !label_name?item:item[label_name] }}</div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LpMultipleColorInput',
    props: {
      list: {
        type: Array,
        default: []
      },
      data: {
        type: Array,
        default: []
      },
      label_name: {
        type: String,
        default: ''
      },
      value_name: {
        type: String,
        default: ''
      }
    },
    methods: {
      checkStyle(item) {
        if (item.color==='#ffffff') {
          return 'color: #000000';
        }
      },
      colorStyle(item) {
        return `background-color: ${item.color}`;
      },
      clickCheck(item) {
        if (this.value_name) {
          if (!this.data.includes(item[this.value_name])) {
            this.data.push(item[this.value_name]);
          } else {
            let index = this.data.indexOf(item[this.value_name])
            if (index >= 0) {
              removeIndex(this.data, index);
            }
          }
        } else {
          if (!this.data.includes(item)) {
            this.data.push(item);
          } else {
            for (let i = 0; i < this.data.length; i++) {
              if (this.data[i] === item) {
                removeIndex(this.data, i);
                break;
              }
            }
          }
        }
        this.$emit('check');
      },
      isSelected(item) {
        if (this.value_name) {
          if (!this.data.includes(item[this.value_name])) return false;
          else return true;
        } else {
          if (!this.data.includes(item)) return false;
          else return true;
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_variable'
  .lp-check-container
    cursor pointer
    display flex
    margin-right 8px

  .sel-btn
    width 16px
    height 16px
    border-radius 3px
    margin auto 0
    margin-right 8px
    border 1px solid #dddddd
    background-color white
    display inline-block
    text-align center

  .checked-icon
    color #ffffff
    font-size 21px
    padding 1.5px
    display flex
    align-items center
    justify-content center
    line-height 30px
    font-weight 300

  .lp-label
    font-size 0.9rem
    line-height 17px

  .color-shape
    width 32px
    height 32px
    border-radius 17px
    border 1px solid #dddddd
</style>
